export const DateService={
    dateEliteFormat(date){
        //let options={ year: 'numeric', month: 'short', day: 'numeric' }
        let eliteDate = !(date instanceof Date) ?  new Date(date) : date;
        // console.log(eliteDate.toLocaleDateString('en', options), "eliteDate.toLocaleDateString('en', options)")
        // return eliteDate.toLocaleDateString('en', options)
        //        .replace(/,/g,'')
        //        .replace(/\s/g,'');

        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(eliteDate);
        const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(eliteDate);
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(eliteDate);
        return `${da}${mo}${ye}`;
    },

    addMonth(dateValue, numberOfMonths) {
        if(!dateValue) return null;
        let date = new Date(dateValue);
        date.setMonth(date.getMonth() + numberOfMonths);
        return this.toInputString(date);
    },

    addDays(dateValue, numberOfDays) {
        if(!dateValue) return null;
        let date = new Date(dateValue);
        date.setDate(date.getDate() + numberOfDays);
        return this.toInputString(date);
    },

    dateNow() {
        let date = new Date();
        return this.toInputString(date);
    },

    toInputString(date) {
        let dateString = date.toDateString();
        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
        const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
        dateString = `${ye}-${mo}-${da}`;
        return dateString;
    },

    getAge(dateString) {
        if(!dateString) return '';
        let today = new Date();
        let birthDate = new Date(dateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    },

    diffDays(dateFrom, dateTo) {
        const date1 = new Date(dateFrom);
        const date2 = new Date(dateTo);
        const diffTime = Math.abs(date2 - date1);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
}